function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  className: "cls-1",
  d: "M112,400.21H74.2v-40c0-20.8,0-20.8-20.9-20.9H0c1.5-9.5,2.6-18,4.2-26.4,1.2-6.1,1.2-14.2,5.1-17.5,3.7-3.1,11.7-1,17.8-1,17.3-.1,21-3.7,21-21.2V124.31c0-16-7.4-23.3-23.5-23.4H.4c0-12.8-.2-24.5.3-36.2C.8,63.31,4.9,61,7.2,61c19.2-.3,38.4-.4,57.5.1,7.3.2,9.9-2,9.6-9.5-.5-14.8,0-29.7-.2-44.5C74,1.81,75.9-.19,81.2,0c9.9.3,19.8.1,30.8.1v45.1c0,16.5-1.4,14,13.8,13.6,15.8-.4,14.7,3.5,14.8-15.5,0-12,.2-24-.1-36.1-.1-5.1,1.3-7.4,6.9-7.2,9.9.4,19.8.1,30.8.1v40.3c0,20.4.1,19.9,20.1,23S237.5,71.71,252,87c25.6,26.9,21.5,72.9-8.1,94.9-1,.7-1.9,1.4-3.9,2.8,6.8,3.1,12.8,5.7,18.5,8.6,19.2,9.8,28.9,25.9,30.6,47.1,1.4,16.8-.2,33.2-6.6,48.9-10.7,26.4-32.6,38.3-58.6,44.1-12.9,2.9-26.2,4.3-39.4,5.6-5,.5-6.5,2.2-6.5,7,.2,15.9-.1,31.7.2,47.6.1,5.3-1.5,7.2-6.9,7-9.9-.4-19.9-.1-30.8-.1v-21c0-10.2-.2-20.5.1-30.7.2-6-1.5-8.7-8.1-8.8-20.6-.6-20.6-.8-20.6,19.5C112,372.81,112,386.11,112,400.21Zm28.1-185.5c-6.9,0-13.8.2-20.7-.1-5.4-.2-7.1,1.9-7,7.1.2,17.4.1,34.7.1,52.1,0,20.9,0,21,21,20.8,20.2-.2,40.3-1.4,59.2-9.7,15.3-6.8,23.1-17.8,22-32.4-1.1-15-10-24.5-23.6-30C174.8,215.71,157.6,214.21,140.1,214.71Zm-27.6-74.8c0,10-.3,19.9.2,29.8.1,2.4,3.2,6.5,5.1,6.5,19.9.4,40,.8,58.7-7.2,6.5-2.8,13.1-7.8,16.9-13.5,11.2-16.8,2.2-38.4-18.7-45.9-18.3-6.6-37.5-7.1-56.6-5.8-2,.1-5.1,4-5.3,6.3C112.2,120,112.5,129.91,112.5,139.91Z"
})));

var SvgBtc = function SvgBtc(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 289.57 400.63",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBtc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btc.6e44dcc2.svg";
export { ForwardRef as ReactComponent };